// extracted by mini-css-extract-plugin
export default {"root":"UsEligibilityCertification_root__lwsFE","finePrint":"UsEligibilityCertification_finePrint__zd8uO marketplaceModalHelperLink"};